import App from '../website/App';

window.App = App;
window.Section = null;


